import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Certifications from "@/pages/Certifications";

export const Route = createFileRoute("/es/certificaciones")({
  head: () => buildRouteHead("/es/certificaciones"),
  component: Certifications,
});

